import Glide from '@glidejs/glide';
import './carousels';
import './forms';

/**
 * Slide out menu
 */
const hamburger = document.querySelector('.a-hamburger');
const slideOut = document.querySelector('.m-slide-out');

function menuToggle(event) {
  event.preventDefault();
  hamburger.classList.toggle('open');
  slideOut.classList.toggle('open');
}

hamburger.addEventListener('touchstart', menuToggle);
hamburger.addEventListener('click', menuToggle);

/**
 * Home page news & events carousel
 */
const glide = document.querySelector('.glide');

if (glide) {
  new Glide('.glide', {
    type: 'slider',
    startAt: 0,
    perView: 1.2,
    gap: 24,
  }).mount();
}

/**
 * Profile updated message
 */
if (window.location.href.indexOf('?updated=true') > -1) {
  const updated = document.querySelector('.updated');
  const string = document.querySelector('.updated p');

  updated.className = 'u-notice u-notice-wordpress u-notice-success';
  string.innerHTML = 'Profile updated';
}

/**
 * Change search results banner headline
 */
if (window.location.href.indexOf('yMin') > -1) {
  const headline = document.querySelector('.l-masthead__content h1');

  headline.innerHTML = 'Find a member';
}

/**
 * Resize t-user-flow to fit viewport height
 */
const userFlow = document.querySelector('.t-user-flow');
let windowHeight;

function resizeUserFlow() {
  windowHeight = window.innerHeight;

  const headerHeight = document.querySelector('.o-header').offsetHeight;
  const mastheadHeight = document.querySelector('.l-masthead').offsetHeight;
  const footerHeight = document.querySelector('.o-footer').offsetHeight;
  const contentHeight = headerHeight + mastheadHeight + footerHeight;
  const userFlowHeight = windowHeight - contentHeight;

  userFlow.style.minHeight = `${userFlowHeight}px`;
}

if (userFlow) {
  window.addEventListener('load', resizeUserFlow);
  window.addEventListener('resize', resizeUserFlow);
}

/**
 * Collect Vimeo Embeds and add wrap
 */

const postContent = document.querySelector('.l-post__content');

/**
 * Check embeds for vimeo link
 */
if (postContent) {
  const embeds = postContent.querySelectorAll('iframe');
  embeds.forEach((embed) => {
    if (embed.src.includes('vimeo')) {
      /**
       * Wrap embedded iframes
       */
      const vimeoWrap = document.createElement('div');
      vimeoWrap.className = 'a-video a-video--vimeo';

      embed.insertAdjacentElement('beforebegin', vimeoWrap);

      vimeoWrap.appendChild(embed);
    }
  });
}

/**
 * Remove gaps in WP Gallery
 */

const brs = document.querySelectorAll('br');

if (brs) {
  brs.forEach((br) => {
    if (br.attributes.length === 1) {
      br.remove();
    }
  });
}
